import { Injectable,Input} from '@angular/core'

@Injectable()
export class UnitUserCommonService {
    // // unitUserShared = new EventEmitter();
    private data:any;

    constructor(){}

    
     setData(data:any)
    {
         this.data = data;
    }

     getData()
    {
        return this.data;
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/common/unit-user.common.service.ts